import BaseContainer from "@base/container/BaseContainer";
import Facade from "@/Facade";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import {Signals} from "@/Imports";
import ScaleManager from "@/stage/ScaleManager";

export default class RewardContainer extends BaseContainer {

  constructor(data) {
    super(data)
    this.init(data)
  }

  init(data) {
    Signals.stopFeature.add(this.onStopFeature, this)
    Signals.showfreebets.add(this.onShowfreebets, this)

    this.animation = new SpineAnimation('reward', () => {

    })
    this.animation.x = 0 // ScaleManager.currentSizes.total.width / 2
    this.animation.x = 0 // ScaleManager.currentSizes.total.height / 2
    this.animation.position.set(440, 290)
    this.animation.visible = false
    this.addChild(this.animation)
  }

  onShowfreebets(value) {
    if(!value) {
      return
    }

    this.animation.visible = true
    this.animation.start(['freebet'], )

    Facade.soundManager.play('gameRewardSound', 0.5)
  }

  onStopFeature(currentBonus) {
    if (!currentBonus) {
      return
    }

    if(currentBonus.tp === "multiplier" && currentBonus.v > 1) {
      this.animation.visible = true
      this.animation.start(['bonus'], )

      Facade.soundManager.play('gameRewardSound', 0.5)
    }
  }
}
